import { useMemo } from 'react';
import { first, get, isEmpty, keys } from 'lodash';
import { buildLinkUrl } from '../links/Link';

export function buildReportingLink(options, uuid) {
    if (options.dashboardLinkConfig) {
        return buildLinkUrl(options.dashboardLinkConfig);
    }

    if (!options.reportingLinkConfig || !uuid) {
        return;
    }

    if (!options.reportingLinkConfig?.mappedFilterParams) {
        return;
    }

    const dataParam = first(keys(options.reportingLinkConfig?.mappedFilterParams));

    if (!dataParam) {
        return;
    }

    return buildLinkUrl(options.reportingLinkConfig, {
        [get(options, `reportingLinkConfig.mappedFilterParams.${dataParam}`)]: { uuid },
    });
}

export default function useBreadcrumb(
    breadCrumbsArray,
    recordId,
    breadcrumbData = {},
    dataProp,
    newBreadCrumbText,
    options = {},
    textSuffix = null
) {
    return useMemo(() => {
        // When no recordId is present, we're creating a new record, so add the newBreadCrumText as the last crumb instead of adding
        // an entity name.
        if (!recordId) {
            return [...breadCrumbsArray, { text: newBreadCrumbText }];
        }

        const reportingLink = buildReportingLink(options, recordId);

        // Build the breadcrumb text with optional suffix
        const baseText = get(breadcrumbData, dataProp, '');
        const breadcrumbText = isEmpty(textSuffix) ? baseText : baseText + textSuffix;

        // We have a recordId, so add the entity name as the last crumb.
        const newBreadCrumbs = [
            ...breadCrumbsArray,
            isEmpty(breadcrumbData) ? { text: '...' } : { text: breadcrumbText },
        ];

        return reportingLink ? [...newBreadCrumbs, { reportingLink }] : newBreadCrumbs;
    }, [breadCrumbsArray, recordId, newBreadCrumbText, breadcrumbData, dataProp, options, textSuffix]);
}
